import { createContext } from "react";

const musicPlayContext = createContext();

export default musicPlayContext;